import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { ChapterGroup } from '../models/chapter-group';
import { createChapterGroupEndpoint } from './const';

export const createChapterGroup = (chapterGroup: ChapterGroup) => {
    return getHttpClient().post({ url: createChapterGroupEndpoint, data: JSON.stringify(chapterGroup) });
};
